import React, { useContext, useState } from 'react';
import { ContextProps } from '../types/ContextProps';
import { UserSettings } from '../types/ViewModel/UserSettings';

type UserSettingsContextType = {
    userSettings: UserSettings | null;
    setUserSettings: (userSettings: UserSettings | null) => void;
    userSettingsLoaded: boolean;
    setUserSettingsLoaded: (isUpdated: boolean) => void;
};

export const UserSettingsContext = React.createContext<UserSettingsContextType>(undefined!);

export const UserSettingsContextProvider = ({ children }: ContextProps) => {
    const [userSettings, setUserSettings] = useState<UserSettings | null>(null);
    const [userSettingsLoaded, setUserSettingsLoaded] = useState<boolean>(false);

    return (
        <UserSettingsContext.Provider
            value={{
                userSettings,
                setUserSettings,
                userSettingsLoaded,
                setUserSettingsLoaded,
            }}
        >
            {children}
        </UserSettingsContext.Provider>
    );
};

export const useUserSettingsStore = () => useContext(UserSettingsContext);
